import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist, mergeChanged} from "../../../Services/BrowserDatabaseFunctions";



export function addEventFlights(_event_id, _newFlights) {
    // Ensure we are always dealing with an array, even if a single flight was passed
    const flightsArray = Array.isArray(_newFlights) ? _newFlights : [_newFlights];

    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // 1. Ensure existing flights is a valid array
                let currentFlights = Array.isArray(event.flights) ? [...event.flights] : [];

                // 2. Process every flight in the incoming batch
                flightsArray.forEach(newFlight => {
                    if (!newFlight) return;

                    // Match by _id (Mongo style) or id (Legacy style)
                    const newFlightId = String(newFlight._id || newFlight.id);

                    const idx = currentFlights.findIndex(existing => {
                        if (!existing) return false;

                        // 🟢 FIXED: Only compare primary keys if they are validly populated (not null/undefined)
                        const newId = newFlight._id || newFlight.id;
                        const existingId = existing._id || existing.id;

                        if (newId != null && existingId != null && String(newId) === String(existingId)) {
                            return true;
                        }

                        // Match Case B: Fallback to dynamic client generation tokens
                        if (newFlight.temp_id != null && existing.temp_id != null && String(newFlight.temp_id) === String(existing.temp_id)) {
                            return true;
                        }

                        return false;
                    });

                    if (idx >= 0) {
                        // Update existing: Merge fields safely
                        currentFlights[idx] = { ...currentFlights[idx], ...newFlight };
                    } else {
                        // Add as new
                        currentFlights.push(newFlight);
                    }
                });

                // 3. Update the event object
                event.flights = currentFlights;

                // 4. Save back to IndexedDB
                // Using structuredClone is cleaner than JSON.parse/stringify if supported
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(`Successfully synced ${flightsArray.length} flights for Event ${_event_id}.`);
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventFlights:", error);
            throw error;
        });
}

export function addEventFlightsOLD(_event_id, _flight) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure flights is an array
                const flights = Array.isArray(event.flights)
                    ? event.flights.slice()
                    : [];

                // prefer matching by id
                const idx = flights.findIndex(m =>
                    m &&
                    _flight &&
                    m.id != null &&
                    _flight.id != null &&
                    String(m.id) === String(_flight.id)
                );

                if (idx >= 0) {
                    // update existing flight; merge only defined fields
                    const base = flights[idx];
                    const patch = _flight;
                    const merged = { ...base };
                    Object.keys(patch).forEach(k => {
                        if (typeof patch[k] !== "undefined") merged[k] = patch[k];
                    });
                    flights[idx] = merged;
                } else {
                    // add new flight
                    flights.push(_flight);
                }

                // write back
                event.flights = flights;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Flight with ID ${_flight.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventFlight:", error);
            throw error;
        });
}

export function updateEventFlight(_event_id, _flight) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure flights is an array
                const flights = Array.isArray(event.flights)
                    ? event.flights.slice()
                    : [];

                // prefer matching by id
                const idx = flights.findIndex(m =>
                    m &&
                    _flight &&
                    m.id != null &&
                    _flight.id != null &&
                    String(m.id) === String(_flight.id)
                );

                if (idx >= 0) {
                    //update the flight financials
                    flights[idx] = {
                        ...flights[idx],
                        amount_total: _flight.amount_total,
                        currency: _flight.currency,
                        attendee: {
                            ...(flights[idx].attendee || {}),
                            is_business_expense: _flight.is_business_expense,
                            business_expense_amount: _flight.business_expense_amount
                        },
                        status: _flight.status,
                        status_timestamp: _flight.status_timestamp,
                    };



                } else {
                    console.warn(`Flight with ID ${_flight.id} not found in event.`);
                    return false;
                }

                // write back
                event.flights = flights;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Flight with ID ${_flight.id} in Event with ID ${_event_id} updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventFlight:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}

export function updateEventFlightStatus(_event_id, _status_data) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            return dataStore.get(_event_id).then(event => {
                if (!event) return false;

                const flights = Array.isArray(event.flights) ? event.flights.slice() : [];

                // FIX: Use _status_data.flight_id to find the match
                const idx = flights.findIndex(m =>
                    m && m.id && _status_data.flight_id &&
                    String(m.id) === String(_status_data.flight_id)
                );

                if (idx >= 0) {
                    // Spread the existing flight and overwrite with NEW live data
                    flights[idx] = {
                        ...flights[idx],
                        status: _status_data.status,
                        status_timestamp: _status_data.status_timestamp,
                        depart_terminal: _status_data.depart_terminal,
                        depart_gate: _status_data.depart_gate,
                        arrive_terminal: _status_data.arrive_terminal,
                        arrive_gate: _status_data.arrive_gate,
                        baggage_claim: _status_data.baggage_claim,
                        delay_minutes: _status_data.delay_minutes
                    };
                } else {
                    console.warn(`Flight ${_status_data.flight_id} not found.`);
                    return false;
                }

                event.flights = flights;
                // Standardize the object before saving
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(`Live status for Flight ${_status_data.flight_id} cached in DB.`);
                    return true;
                });
            });
        });
}


export function deleteEventFlight(_event_id, _flight_id) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite"); // Use 'readwrite' mode for updates
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                const flights = Array.isArray(event.flights)
                    ? event.flights
                    : [];

                // Filter out the flight with the specified ID
                const updatedFlights = flights.filter(flight => {
                    if (!flight) return false;
                    return String(flight.id) !== String(_flight_id);
                });

                // Update the event with the modified flights array
                event.flights = updatedFlights;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated event back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Flight with ID ${_flight_id} in Event with ID ${_event_id} deleted successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in deleteEventFlight:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}

